// .pen: NDqBP (ds/selfie/report-link-card)
import { Link } from 'react-router-dom';
import { CaretRight, Sparkle } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * Cartão clicável para o relatório IA — usado na Revelação e no touchpoint
 * do Dashboard quando há um relatório pronto por abrir.
 */
export function SelfieReportLinkCard({ href, title, subtitle, className }) {
  return (
    <Link
      to={href}
      data-ds-id="ds/selfie/report-link-card"
      className={cn(
        'flex w-full items-center gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 shadow-[0_6px_16px] shadow-glass-shadow transition hover:border-sage-300 dark:hover:border-sage-600',
        className,
      )}
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-ds-md bg-sage-tint text-sage-on-tint">
        <Sparkle className="size-[21px]" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block type-label-lg font-semibold text-card-foreground">{title}</span>
        <span className="mt-0.5 block text-type-body-sm text-muted-foreground">{subtitle}</span>
      </span>
      <CaretRight className="size-[18px] shrink-0 text-muted-foreground" aria-hidden />
    </Link>
  );
}

export default SelfieReportLinkCard;
